export default "__VITE_ASSET__HbAS8m0G__"